import clsx from "clsx";
import { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

export const ModalBtn: React.FC<
  DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > & {
    opts?: ("cancel" | "primary" | "loading" | "md" | boolean | undefined)[];
  }
> = ({ className, children, opts, ...props }) => {
  return (
    <button
      {...props}
      disabled={opts?.includes("loading") || props.disabled}
      className={clsx(
        "w-full rounded-[3.4375rem] py-[0.8125rem] text-base font-semibold leading-[1.25rem] text-[#232323]",
        opts?.includes("cancel") && "border border-[#232323] hover:bg-gray-100",
        opts?.includes("primary") &&
          (opts?.includes("loading")
            ? "bg-primary text-white"
            : "bg-[#DBE7FF] text-primary-light hover:bg-primary hover:text-white"),
        opts?.includes("md") && "max-w-[11.25rem]",
        className,
      )}
    >
      {children}
    </button>
  );
};
